import React from 'react';
import './VisualizationCard.css';

interface CrateUsageCardProps {
  crateCount: number;
}

const CrateUsageCard: React.FC<CrateUsageCardProps> = ({ crateCount }) => {
  const maxCrates = 2;
  const percentage = (crateCount / maxCrates) * 100;
  
  // Color logic: green at 50%, red at 100%
  const getColor = () => {
    if (crateCount === 0) return '#e0e0e0';
    if (crateCount === 1) return '#10b981'; // green
    return '#dc3545'; // red
  };

  const showUpgradePrompt = crateCount === maxCrates;

  return (
    <div className="visualization-card">
      <h3 className="card-title">Crate Usage</h3>
      <div className="card-content">
        <div 
          className="progress-bar-container" 
          role="progressbar" 
          aria-valuenow={crateCount} 
          aria-valuemin={0} 
          aria-valuemax={maxCrates}
          aria-label={`${crateCount} out of ${maxCrates} crates used`}
        >
          <div 
            className="progress-bar-fill" 
            style={{ 
              width: `${percentage}%`,
              backgroundColor: getColor()
            }}
          />
        </div>
        <div className="usage-text">
          {crateCount} / {maxCrates} Crates
        </div>
        {showUpgradePrompt && (
          <div className="upgrade-prompt">
            You've reached your crate limit. Upgrade for more!
          </div>
        )}
      </div>
    </div>
  );
};

export default CrateUsageCard;
